import React from "react";
import BottomNav from "@/components/BottomNav";

export default function AppShell({ children, hideNav = false, hideFrame = false }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className={`mx-auto max-w-md min-h-screen ${hideFrame ? "" : "sm:border-x sm:border-white/5"} relative pb-28`}>
        {children}
      </div>
      {!hideNav && <BottomNav />}
    </div>
  );
}
